export default __webpack_public_path__ + "static/media/GMaduroChurchillClosed.855d6539.jpg";